"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of a table summary.
 * This does not follow the Impl pattern as it is just a property bag.
 */
class TableSummary {
    constructor(_tableInfo) {
        this._tableInfo = _tableInfo;
    }
    get name() {
        return this._tableInfo.name;
    }
    get id() {
        return this._tableInfo.id;
    }
    get connectionId() {
        return this._tableInfo.connectionId;
    }
    get customSQL() {
        return this._tableInfo.customSQL;
    }
}
exports.TableSummary = TableSummary;
//# sourceMappingURL=TableSummary.js.map